/** Localhost talks to the local API. It does not write Firebase. */

export function writesStayLocal() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}
